import angular from 'angular';
import { clearDirtyForm, isAnyDirtyForm } from 'app/actions/dirty-forms.actions';
import template from './impersonating-bar.html';

import confirmTemplate from '../../../utils/dirty-form/views/confirm-dialog.html';

const mapStateToThis = ({ session }) => ({
  session,
});

const mapDispatchToThis = {
  clearDirtyForm,
  isAnyDirtyForm,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications')
class ImpersonatingBarController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  loginBack() {
    if (this.isAnyDirtyForm()) {
      return this.Notifications.showSimpleDialog(confirmTemplate).result.then(() => {
        this.clearDirtyForm();
        return this.doLoginBack();
      });
    }
    return this.doLoginBack();
  }

  doLoginBack() {
    return this.api.loginBack.run().then((newModel) => this.api.redirectAfterLogin(newModel, null, {}, { reload: true }));
  }
}

class ImpersonatingBarComponent {
  constructor() {
    this.controller = ImpersonatingBarController;
    this.template = template;
    this.bindings = {
      model: '<',
      api: '<',
    };
    return this;
  }
}

angular.module('impersonating-bar', []).component('impersonatingBar', new ImpersonatingBarComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/impersonating-bar/impersonating-bar-component.js